module.exports = __webpack_public_path__ + "assets/img/logo_black.a0331f6c.png";